import { __awaiter } from "tslib";
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, dom, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { Card } from '@holmescorp/card';
import { ExpandedBaseCard } from '@holmescorp/card/cards/widgets/expandedBase';
import { convertToBoolean } from '@holmescorp/common';
import { createNlsMiddleware, exploreToolChange, userstate } from '@holmescorp/lcc-state';
import { subscribe } from '@holmescorp/pub-sub';
import css from '../css/cert-card.m.css';
import { check_rpc_passed, load_cert, print_cert } from '../support/utils';
const icache = createICacheMiddleware();
const factory = create({
    icache,
    nls: createNlsMiddleware('certificate'),
    theme,
    userstate
}).properties();
export const CertificateCard = factory(({ properties, middleware: { icache, nls, theme, userstate } }) => {
    const { xqa, key = 'certificate', title = 'Certificate of Acheivement', mediaSrc = '', mediaTitle = title, subtitle = '', nlsKey = '', ispromotedisabled = 'true', ispromotable = 'false', ispromoted = 'false' } = properties();
    const { format, messages: { use_confirmation = '[certificate] use_confirmation', print_instructions = '[certificate] print_instructions', unearned_instructions = '[certificate] unearned_instructions', congratulations = '[certificate] congratulations', continue_button_text = '[certificate] continue_button_text', print_button_text = '[certificate] print_button_text', confirmation_prompt = '[certificate] confirmation_prompt', confirmation_title = '[certificate] confirmation_title', confirmation_text = '[certificate] confirmation_text' } } = nls();
    const { messages } = nls();
    const { get, path } = userstate;
    const useConfirmation = convertToBoolean(use_confirmation);
    const { extra: exploreTool } = get(path('toolstate', 'explore'));
    const certificateAttested = exploreTool && exploreTool.certificateAttested;
    const expanded = icache.getOrSet('expanded', false);
    const certLoaded = icache.getOrSet('certLoaded', false);
    const themeCss = theme.classes(css);
    subscribe('cert/loaded', () => __awaiter(void 0, void 0, void 0, function* () {
        icache.set('certLoaded', true);
    }));
    const earned = icache.getOrSet('earned', () => __awaiter(void 0, void 0, void 0, function* () {
        const posttest = get(path('posttest'));
        const userid = get(path('user_id'));
        return posttest && posttest.passed ? true : yield check_rpc_passed(userid);
    }));
    const instructions = earned ? `${congratulations}\n\n${print_instructions}` : unearned_instructions;
    const subtitle_text = subtitle
        ? v('div', { classes: [themeCss.subtitle] }, [subtitle])
        : v('div', { classes: [themeCss.subtitle], innerHTML: instructions });
    const content = v('div', { classes: themeCss.content }, [
        title ? v('div', { classes: [themeCss.title] }, [title]) : null,
        subtitle_text,
        v('div', { classes: [themeCss.actions] }, [
            useConfirmation && !certificateAttested
                ? w(Button, {
                    onClick: () => {
                        icache.set('expanded', true);
                    }
                }, [
                    {
                        label: continue_button_text
                    }
                ])
                : w(Button, {
                    disabled: !certLoaded || !earned,
                    onClick: () => {
                        print_cert();
                    }
                }, [
                    {
                        label: print_button_text
                    }
                ])
        ])
    ]);
    const expandedContent = v('div', { classes: [theme.variant(), themeCss.root, 'expanded'] }, [
        v('div', { classes: [themeCss.content] }, [
            v('div', { innerHTML: confirmation_prompt }),
            v('div', { classes: [themeCss.actions] }, [
                w(Button, {
                    onClick: () => {
                        exploreToolChange({ extra: { certificateAttested: true } });
                        icache.set('expanded', false);
                    }
                }, [{ label: confirmation_text }])
            ])
        ])
    ]);
    const printElements = () => {
        const _canvas = document.createElement('canvas');
        const _printNode = document.createElement('iframe');
        const learnerName = get(path('fullname'));
        return v('div', {}, [
            dom({ node: _canvas }),
            dom({
                node: _printNode,
                onAttach: () => load_cert({
                    messages,
                    learnerName,
                    canvas: _canvas,
                    printNode: _printNode
                })
            })
        ]);
    };
    return v('div', { xqa, classes: [theme.variant(), themeCss.root, 'expanded'] }, [
        expanded
            ? w(ExpandedBaseCard, {
                expanded: icache.get('expanded') || false,
                title: confirmation_title,
                xqa: `${key}-expanded`,
                onRequestClose: () => {
                    icache.set('expanded', false);
                }
            }, [{ content: expandedContent }])
            : null,
        w(Card, {
            xqa: `card-${title}-${key}`,
            mediaSrc,
            mediaTitle,
            nlsKey,
            ispromotable,
            ispromotedisabled,
            ispromoted
        }, [
            {
                content
            }
        ]),
        useConfirmation && !certificateAttested ? null : printElements()
    ]);
});
export default CertificateCard;
